import { Component } from '@angular/core';

@Component({
  selector: 'mpp-country-selection-footer',
  templateUrl: './country-selection-footer.component.html',
  styleUrls: ['./country-selection-footer.component.scss'],
  standalone: false,
})
export class CountrySelectionFooterComponent {}
